<template>
  <section id="features" class="features">
    <h2>Why Feed Lead?</h2>
    <div class="feature-grid">
      <div v-for="feature in features" :key="feature.id" class="feature-card">
        <div class="feature-icon">{{ feature.icon }}</div>
        <h3>{{ feature.title }}</h3>
        <p>{{ feature.description }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        {
          id: 1,
          icon: '🎯',
          title: 'Smart Lead Detection',
          description: 'Identify the most suitable leads for your ideal customer profile using AI-powered algorithms.'
        },
        {
          id: 2,
          icon: '✍️',
          title: 'Automated Content Creation',
          description: 'Generate personalized outreach messages with AI assistance.'
        },
        {
          id: 3,
          icon: '🤖',
          title: 'FAQ Automation',
          description: 'Automate customer interactions with chatbot and smart FAQ system.'
        },
        {
          id: 4,
          icon: '📅',
          title: 'Meeting Scheduler',
          description: 'Automatically schedule discovery meetings and sync with your calendar.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.features {
  padding: 4rem 2rem;
  background: white;
}

.feature-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
}

.feature-card {
  padding: 2rem;
  border-radius: var(--border-radius);
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 2rem;
}

h3 {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
</style> 